import { Typography } from '@material-ui/core'
import PropTypes from 'prop-types'
import React from 'react'

import ModalComponent from '~/components/Modal'

function DeleteDomain({ state: { open, validator }, actions: { handleClose, handleSubmit } }) {
  const [domainName, setDomainName] = React.useState('')

  const inputs = [
    {
      component: 'textField',
      fullWidth: true,
      name: 'domain-name',
      type: 'text',
      label: (
        <>
          Para confirmar, por favor digite <b>{validator}</b>
        </>
      ),
      onChange: (event) => setDomainName(event.target.value),
    },
  ]

  const buttons = [
    {
      variant: 'outlined',
      customClass: 'error',
      name: 'Sim, exclua este domínio',
      disabled: validator !== domainName,
      handleSubmit,
    },
  ]

  return (
    <ModalComponent
      actions={{ handleClose }}
      state={{ open, title: 'Tem certeza?', inputs, buttons }}
    >
      <Typography variant="h6" gutterBottom>
        Tem certeza que deseja excluir este domínio?
      </Typography>
      <Typography variant="body2" className="disclaimer" my={3}>
        Ao deletar este domínio, ele ficará disponível para adição em nosso sistema. Os funis
        atualmente atribuídos a ele, serão movidos para seu domínio base da MakeFunnels.
      </Typography>
    </ModalComponent>
  )
}

DeleteDomain.propTypes = {
  state: PropTypes.shape({
    open: PropTypes.bool,
    validator: PropTypes.string,
  }),
  actions: PropTypes.shape({
    handleClose: PropTypes.func,
    handleSubmit: PropTypes.func,
  }),
}

export default DeleteDomain
